import { render } from "./CoverageDetails.vue?vue&type=template&id=57aa9ff3"
import script from "./CoverageDetails.vue?vue&type=script&lang=js"
export * from "./CoverageDetails.vue?vue&type=script&lang=js"

import "./CoverageDetails.vue?vue&type=style&index=0&id=57aa9ff3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__